<template>
  <div>
    <SectionWrapper>
      <Login :enable-third-party="false">
        <template slot="formBottom">
          <router-link :to="{ name: pages.AUTH_EMBED_PASSWORD_REMINDER }"
            >Forgot Your Password?</router-link
          >
        </template>
      </Login>
    </SectionWrapper>
    <DividerSeparator class="compact light">
      <DecoratedButton
        type="link"
        name="register-button"
        :route="{ name: pages.AUTH_EMBED_REGISTER }"
        class="wide short dark-blue"
        fontSize=".8em"
      >
        CREATE AN ACCOUNT
      </DecoratedButton>
    </DividerSeparator>
  </div>
</template>

<script>
import ThirdPartyLogin from "@/components/partials/auth/ThirdPartyLogin";

import FormWithCaptcha from "@/components/partials/FormWithCaptcha";

import Login from "@/components/partials/auth/Login";

export default {
  name: "auth-embed-login",
  components: { FormWithCaptcha, Login, ThirdPartyLogin }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
